@for (exercise of exercises; track exercise) {
  <div class="wrapper">
    <div class="panel ex-name">
      <span>{{ exercise.display_name || exercise.name }}</span>
    </div>
    <div class="row">
      <div class="panel progress">
        @if (withCheckboxes) {
          <lib-checkbox [readOnly]="true" [initValue]="exercise.score?.is_passed"> </lib-checkbox>
        }
        <lib-progress-bar-text
          [length]="exercise.score?.total_unique || 1"
          [current]="$safeNavigationMigration(exercise.score?.valid)"
          [progressColor]="standalone ? '#F2BF5E' : '#ffd787'"
          type="percent"
          [maxBarWidth]="108"
          textPosition="right"
        ></lib-progress-bar-text>
      </div>
      <div class="panel">
        @if (!exercise.score?.is_passed) {
          <button class="btn primary h-sm w-sm" (click)="handleStartExercise(exercise)">
            <span> {{ 'global.start' | transloco }}</span>
          </button>
        }
        @if (exercise.score?.is_passed && exercise.replayable) {
          <button class="btn basic h-sm w-sm" (click)="handleStartExercise(exercise)">
            <span inlineSVG="/icons/icon-restart.svg"></span>
            {{ 'global.restart' | transloco }}
          </button>
        }
      </div>
    </div>
  </div>
}
